import React from "react";

export default function StatCard({ icon: Icon, label, value, sub, accent = false, demo = false, testId }) {
  return (
    <div
      data-testid={testId}
      className={`relative rounded-2xl border p-5 transition-all duration-300 group ${
        accent
          ? "bg-gradient-to-br from-[#FF5500] to-[#e04b00] border-transparent"
          : "bg-[#13131C] border-[#222230] hover:border-[#FF5500]/40 hover:bg-[#1B1B27]"
      }`}
    >
      {demo && (
        <span className="absolute top-3 right-3 text-[9px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-[#F59E0B]/15 text-[#F59E0B] border border-[#F59E0B]/30">
          Demo
        </span>
      )}
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-4 ${accent ? "bg-white/20" : "bg-[#FF5500]/10"}`}>
        {Icon && <Icon size={20} className={accent ? "text-white" : "text-[#FF5500]"} strokeWidth={2.2} />}
      </div>
      <p className={`text-xs font-medium uppercase tracking-wider ${accent ? "text-white/80" : "text-[#68687B]"}`}>{label}</p>
      <p className={`font-mono font-extrabold text-2xl sm:text-3xl mt-1 ${accent ? "text-white" : "text-white"}`}>{value}</p>
      {sub && <p className={`text-xs mt-1.5 ${accent ? "text-white/70" : "text-[#A0A0B2]"}`}>{sub}</p>}
    </div>
  );
}
